
import {of as observableOf, Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {CommonService} from '../../common/controller/common.service';
import {ApiMessageService} from '../../core/api-message.service';
import {Fascia} from './fascia.model';
import {Router} from '@angular/router';
import {JsonBaseBuilder} from '../../common/builder/json-base-builder';
import {ConfigService} from '../../core/config.service';
import {Table} from '../../common/model/table.model';
import {MODULE_CONFIGURAZIONE} from '../../app-routing.module';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class FasciaService extends CommonService<Fascia> {

  public static ROUTE = 'fascia';

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected router: Router,
                     protected configService: ConfigService,
                     protected translateService: TranslateService) {
    super(httpClient, apiMessageService, router, configService);
  }

  public buildInstance(json: any): Fascia {
    return JsonBaseBuilder.jsonToFascia(json);
  }

  public getModule(): string {
    return MODULE_CONFIGURAZIONE;
  }

  public getApiService(): string {
    return ConfigService.ACE;
  }

  public getRoute(): string {
    return FasciaService.ROUTE;
  }

  public existingDescr(descr: string, entity: Fascia): Observable<boolean> {
    return this.getBoolean('/existingdescr', new HttpParams()
      .set('descr', descr)
      .set('id', entity?.getId() ? entity?.getId() + '' : ''));
  }

  public existingSigla(sigla: string, entity: Fascia): Observable<boolean> {
    return this.getBoolean('/existingsigla', new HttpParams()
      .set('sigla', sigla)
      .set('id', entity?.getId() ? entity?.getId() + '' : ''));
  }

  public permittedForUrl(urls: string): Observable<Fascia[]> {
    return observableOf([]);
  }

  public getTable(items: Fascia[]): Table {
    return Table.buildBaseTable(Fascia.getTableKeys(), items, this.translateService);
  }
}
